import { render, staticRenderFns } from "./AcaoObjetoList.vue?vue&type=template&id=953fb59e&scoped=true"
import script from "./AcaoObjetoList.vue?vue&type=script&lang=js"
export * from "./AcaoObjetoList.vue?vue&type=script&lang=js"
import style0 from "./AcaoObjetoList.vue?vue&type=style&index=0&id=953fb59e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953fb59e",
  null
  
)

export default component.exports